// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "table[data-v-5a279833],tr[data-v-5a279833]{width:100%}.colorhead[data-v-5a279833]{padding:5px;border-radius:0 20px 20px 0}.colorhead[data-v-5a279833],.green[data-v-5a279833]{background-color:green}.yellow[data-v-5a279833]{background-color:gold}.pink[data-v-5a279833]{background-color:#db7093}", ""]);
// Exports
module.exports = exports;
